// Native <details> remains usable without JavaScript. Escape/outside click close it.
document.addEventListener('click', (event) => {
  document.querySelectorAll('[data-sc-region-picker][open]').forEach((picker) => {
    if (!picker.contains(event.target)) picker.open = false;
  });
});
document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;
  const picker = document.activeElement?.closest('[data-sc-region-picker][open]');
  if (!picker) return;
  picker.open = false;
  picker.querySelector('summary')?.focus();
  event.preventDefault();
});
